import { render, staticRenderFns } from "./ownerList.vue?vue&type=template&id=5266e63c&scoped=true&"
import script from "./ownerList.vue?vue&type=script&lang=ts&"
export * from "./ownerList.vue?vue&type=script&lang=ts&"
import style0 from "./ownerList.vue?vue&type=style&index=0&id=5266e63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5266e63c",
  null
  
)

export default component.exports